import React from 'react'

import './QbText.css'
import { mergeToNewObject } from '../../../util/helpers'

const QbText = ({ children, large, style }) => {
  function getStyle() {
    return large ? mergeToNewObject(TEXT_STYLE.large, style) : mergeToNewObject(TEXT_STYLE.medium, style)
  }
  return (
    <div
      className="qb-text-container"
      style={getStyle()}
    >
      {children}
    </div>
  )
}

const TEXT_STYLE = {
  large: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '27px'
  },
  medium: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '20px'
  }
}

export default QbText



// WEBPACK FOOTER //
// ./src/components/shared/QbText/QbText.js